/* eslint-disable import/no-anonymous-default-export */
import { useEffect } from "react"


export default (event: string, callback, deps: any[] = []) => {
	useEffect(() => {
		window.addEventListener(event, callback)
		return () => window.removeEventListener(event, callback)
	}, deps)
}